import React from "react";

interface Props { }

export const FacebookIconComponent: React.SFC<Props> = () => {
  return (
    // tslint:disable:max-line-length
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 0.669643C12 0.482143 11.9196 0.321429 11.7857 0.1875C11.6518 0.0803571 11.4911 0 11.3304 0H0.669643C0.455357 0 0.294643 0.0803571 0.1875 0.1875C0.0535714 0.321429 0 0.482143 0 0.669643V11.3304C0 11.5179 0.0535714 11.6786 0.1875 11.8125C0.294643 11.9464 0.455357 12 0.669643 12H6.40179V7.33929H4.84821V5.54464H6.40179V4.20536C6.40179 3.45536 6.61607 2.86607 7.04464 2.4375C7.47321 2.03571 8.03571 1.82143 8.73214 1.82143C9.26786 1.82143 9.75 1.84821 10.125 1.875V3.50893H9.16071C8.8125 3.50893 8.57143 3.58929 8.4375 3.75C8.33036 3.88393 8.27679 4.09821 8.27679 4.39286V5.54464H10.0714L9.83036 7.33929H8.27679V12H11.3304C11.5179 12 11.6786 11.9464 11.8125 11.8125C11.9196 11.6786 12 11.5179 12 11.3304V0.669643Z" fill="white" />
    </svg>
    // tslint:enable:max-line-length
  );
};
